module.exports = {
  apiURL: 'https://api.zenfitapp.com/gym/v1/api',
  interactiveLoginURL: 'https://app.zenfitapp.com/login/interactive',
  leadURL:'https://app.zenfitapp.com/dashboard/leads',
  clientURL:'https://app.zenfitapp.com/dashboard/clients'
}
